import {
  DeleteOutlined as DeleteOutlinedAntd,
  FormOutlined as FormOutlinedAntd,
} from '@ant-design/icons';
import {
  Button as ButtonAntd,
  Card as CardAntd,
  Col,
  Row as RowAntd,
  Spin as SpinAntd,
  Table as TableAntd,
  Typography as TypographyAntd,
} from 'antd';
import styled from 'styled-components';

export const ContainerButtons = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
`;

export const Card = styled(CardAntd)`
  .ant-card-body {
    padding: 24px;
  }
`;

export const ColCard = styled(Col)`
  padding: 24px 30px;
`;

export const AddButton = styled(ButtonAntd)`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  color: #fff;
  border: 1px solid #24a95d;
  border-radius: 2px !important;
  background: #24a95d;

  &:hover,
  &:focus,
  &:active {
    color: #fff;
    border-color: #25b663;
    background-color: #25b663;
  }
`;

export const SubTitle = styled.span`
  display: block;
`;

export const Title = styled(TypographyAntd.Title)`
  font-family: Roboto !important;
  font-style: normal !important;
  font-weight: bold !important;
  font-size: 18px !important;
  line-height: 22px !important;
  color: #000000 !important;
`;

export const Table = styled(TableAntd)`
  .ant-table {
    border-bottom: 1px solid #dfdfdf;
    overflow: auto;
    max-height: 500px;
  }

  .ant-table,
  .ant-table-thead > tr > th {
    color: #676a6c;
  }

  .ant-table-thead > tr > th {
    font-weight: 700;
    font-size: 14px;
    background: #f5f5f6;
    color: #000000;
    font-family: Roboto;
    font-style: normal;
  }

  table tr > td {
    padding: 4px 16px;
    background: #ffffff;
    color: #000000;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
  }
`;

export const ActionButton = styled(ButtonAntd)`
  padding: 0;
  color: #6bbc60;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;

  &:hover {
    color: #6bbc60;
  }
`;

export const FormOutlined = styled(FormOutlinedAntd)`
  color: #000000;
  font-size: 20px;

  :hover {
    opacity: 0.6;
  }
`;

export const DeleteOutlined = styled(DeleteOutlinedAntd)`
  color: #000000;
  font-size: 20px;

  :hover {
    opacity: 0.6;
  }
`;

export const FormInputButton = styled(RowAntd)`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const Spin = styled(SpinAntd)`
  width: 100%;

  .ant-spin-dot-item {
    background-color: #24a95d !important;
  }
`;
